import { ApiBase } from '@/api/methods/ApiBase'
import {
  ApiResponseUserReviewProblemRegistered,
  ApiResponseUserReviewProblemCurriculumUnits,
  ApiResponseUserReviewProblems,
} from '@/api/responses/userReviewProblems'

export namespace UserReviewProblemsApi {
  /**
   * 復習BOX問題登録状況取得
   *
   * @param fixedExerciseId 固定問題ID
   * @param problemCode 小問コード
   * @returns 復習BOXに登録済みか否か
   */
  export async function getRegistered(
    fixedExerciseId: number,
    problemCode: string
  ): Promise<ApiResponseUserReviewProblemRegistered> {
    const params = {
      fixedExerciseId: fixedExerciseId,
      problemCode: problemCode,
    }
    return await ApiBase.get('/userReviewProblems/registered', params)
  }

  /**
   * 復習BOX問題登録
   *
   * @param fixedExerciseId 固定問題ID
   * @param problemCode 小問コード
   */
  export async function postCreate(fixedExerciseId: number, problemCode: string): Promise<void> {
    const params = {
      fixedExerciseId: fixedExerciseId,
      problemCode: problemCode,
    }
    await ApiBase.post('/userReviewProblems/create', params)
  }

  /**
   * 復習BOX問題削除
   *
   * @param fixedExerciseId 固定問題ID
   * @param problemCode 小問コード
   */
  export async function postDelete(fixedExerciseId: number, problemCode: string): Promise<void> {
    const params = {
      fixedExerciseId: fixedExerciseId,
      problemCode: problemCode,
    }
    await ApiBase.post('/userReviewProblems/delete', params)
  }

  /**
   * 復習BOX単元一覧取得
   *
   * @param subjectCode 教科コード
   * @param gradeCode 学年コード
   * @returns 単元一覧
   */
  export async function listCurriculumUnits(
    subjectCode: string,
    gradeCode: string
  ): Promise<ApiResponseUserReviewProblemCurriculumUnits> {
    const params = {
      subjectCode: subjectCode,
      gradeCode: gradeCode,
    }
    return await ApiBase.get('userReviewProblems/curriculumUnits', params)
  }

  /**
   * 復習BOX単元別問題一覧取得
   *
   * @param curriculumUnitId 単元ID
   * @param subjectCode 教科コード
   * @param gradeCode 学年コード
   * @returns 単元別問題一覧
   */
  export async function listCurriculumUnitProblems(
    curriculumUnitId: number,
    subjectCode: string,
    gradeCode: string
  ): Promise<ApiResponseUserReviewProblems> {
    const params = {
      subjectCode: subjectCode,
      gradeCode: gradeCode,
    }
    return await ApiBase.get(`userReviewProblems/curriculumUnits/${curriculumUnitId}/problems`, params)
  }
}
